import { PageId } from 'constants/pages'

export const enum PageIdWoofzHlwn80 {
  SUBSCRIPTIONS_PAGE_HLWN_80 = PageId.SUBSCRIPTIONS_PAGE_HLWN_80,
  CHAT_UPSELL_HLWN_80 = PageId.CHAT_UPSELL_HLWN_80,
  UPSELL_HLWN_80 = PageId.UPSELL_HLWN_80,
  DOWNLOAD_HLWN_80 = PageId.DOWNLOAD_HLWN_80,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
